// extracted by mini-css-extract-plugin
export default {"imageWrapper":"hJ-z","twoColumnImage":"iJ-z"};